<template>
	<modal
        id="add-user-modal"
		title="Add user"
        :subtitle="group ? group.reportName : 'group'"
		:active="active"
        :loading="loading"
		:dismissable="true"
		:max-width="1024"
		@dismiss="dismiss"
	>

		<modal-body class="p-0">
            <user-picker
                source="registered"
                :location-group-id="locationGroupId"
                @change="onUserChange"
            />
		</modal-body>

		<modal-actions>
			<btn primary @click="cancel">Cancel</btn>
		</modal-actions>
		
	</modal>
</template>


<script>
    import _ from 'lodash';
	import { notifications } from 'pdk/services';
	import { AsyncMixin, ModalMixin } from 'pdk/mixins';
    import { groups } from '@/services';
    import { UserPicker } from '@/components/users';

	export default {
		name: 'add-registered-user-modal',
		components: {
			UserPicker
        },
        mixins: [AsyncMixin, ModalMixin],
        props: {
            locationGroupId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                group: undefined
            };
        },
        created() {
            groups.getGroup({
                locationGroupID: this.locationGroupId
            }).then((group) => {
                this.group = group;
            });
        },
		methods: {
            onUserChange(user) {
                this.$emit('change', user);

                this.async(groups.addUser({
                    locationGroupID: this.locationGroupId,
                    requests: [{
                        locationGroupID: this.locationGroupId,
                        globalUserID: user.globalUserID,
                        role: 1 // Member
                    }]
                })).then(() => {
                    this.$emit('add', user);
                    notifications.open({
                        content: `User added to ${this.group.reportName}`
                    });
                    this.close();
                });
            }
		}
	};
</script>

<style lang="scss">
@import '~@/assets/styles/references';

  #add-users-grid .k-command-cell {
	padding: 4px 8px;
	text-align: center;
  }

  #add-users-grid .k-button {
    margin: calc( (1.42857em + (-1 * calc( 4px + 1.42857em)))/2) 0 calc( (1.42857em + (-1 * calc( 3px + 1.42857em)))/2) 0;
	min-width: 0;
  }

  #add-users-grid .k-icon {
	  margin: 0 auto;
  }

</style>
